import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime'
import { forwardRef } from 'react'
const SvgBrandIconNowDelivery = (props, ref) =>
  _jsxs('svg', {
    viewBox: '0 0 48 48',
    xmlns: 'http://www.w3.org/2000/svg',
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    ref: ref,
    ...props,
    children: [
      _jsx('circle', { cx: 24, cy: 24, r: 24, fill: '#fcf7f7' }),
      _jsx('path', {
        d: 'M26.187 13.136v11.045a2.206 2.206 0 0 1-2.206 2.206H16.26a.715.715 0 0 1-.714-.714V22.69c0-.395.32-.714.714-.714h5.516v-8.84c0-.395.32-.714.714-.714h2.983c.395 0 .714.32.714.714m-1.556 34.856C11.381 48.34.357 37.882.008 24.63S10.118.357 23.37.008C36.62-.34 47.643 10.118 47.992 23.37c.348 13.25-10.11 24.274-23.361 24.623m14.806-23.993c0-8.643-6.792-15.437-15.437-15.437S8.562 15.356 8.562 24.001 15.355 39.437 24 39.437 39.437 32.644 39.437 24',
      }),
    ],
  })
const ForwardRef = forwardRef(SvgBrandIconNowDelivery)
export default ForwardRef
